/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Scroll on click collection description */
if(window.location.pathname != '/pages/marcas'){
  function scrollTo(element) {
  const headerHeight = document.getElementById('shopify-section-header').clientHeight;
    window.scroll({
      behavior: 'smooth',
      left: 0,
      top: element.offsetTop - headerHeight
    });
  }

  const descClickTrigger = document.getElementById("description-cut");

  if(descClickTrigger){
  descClickTrigger.addEventListener('click', () => {
    scrollTo(document.getElementById("description-full"));
  });
  }
}
/* Product add button is on viewport */

function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)

    );
}

document.addEventListener('scroll', function () {

  const btnAdd = document.getElementById('prod-btns');
  const btnSticky = document.querySelector('.sticky-add-btn');
  
  if (btnAdd && window.innerWidth < 641) {
  isInViewport(btnAdd) ? btnSticky.classList.remove('show') : btnSticky.classList.add('show')
  }
});

/* Quantity buttons on product add button at page bottom */
const btnLess = document.getElementById('minus');
const btnPlus = document.getElementById('plus');

const stickValue = document.getElementById('stick-value');
const stickLess = document.getElementById('stick-less');
const stickPlus = document.getElementById('stick-plus');

if(btnLess) {
btnLess.addEventListener("click", function(){
  console.log('less', stickValue.value);
  if(stickValue.value == 1) {
  	return;
  } else {
    stickValue.setAttribute('value', parseInt(stickValue.value) - 1);
  }
});
}
if(btnPlus) {
btnPlus.addEventListener("click", function(){
  stickValue.setAttribute('value', parseInt(stickValue.value) + 1);
});
}
if(stickLess) {
stickLess.addEventListener("click", function(){
document.querySelector('[data-action="decrease-picker-quantity"]').click();
});
}
if(stickPlus) {
stickPlus.addEventListener("click", function(){
 document.querySelector('[data-action="increase-picker-quantity"]').click();
});
}


